
export const buttonObject = {
    className:"btn btn-primary",
    title:"",
    href:"#",
    target:"_self",
    icon:<></>,
    iconPostion:"right"
}


export const serviceObject = [
    {
        id:1,
        title:"Design",
        slug:"design",
        image_url:"/services/pen.svg",
        description:"We address the seemingly regime of design to deliver you outstanding services. The attractive interface design for a platform is to the appeal of customers, they amaze you with unique and effective user experience design.",
        link:"#!",
    },
    {
        id:2,
        title:"Development",
        slug:"development",
        image_url:"/services/coding.svg",
        description:"Modern mobile first & responsive approach for highly customized Wordpress website, plugins, hosting and robust E-commerce development for your website.",
        link:"#!",
    },
    {
        id:3,
        title:"ECommerce",
        slug:"e-commerce",
        image_url:"/services/shopping-cart.svg",
        description:"Grow your online business with our flexible and powerful eCommerce solutions with Magento, Opencart, WooCommerce and shopify.",
        link:"#!",
    },
    {
        id:4,
        title:"Mobile Apps",
        slug:"mobile-apps",
        image_url:"/services/mobile.svg",
        description:"Our mobile app development services offer modern, feature-rich solutions for iOS, Android and cross-platform mobile apps. We also build amazing wearable solutions.",
        link:"#!",
    },
    {
        id:5,
        title:"Technology",
        slug:"technology",
        image_url:"/services/interactivity.svg",
        description:"At Vital, we choose the technology and tools to realise your vision, from cutting edge features or multi-stack frameworks to ensure your product is ready to help your business grow.",
        link:"#!",
    },
    {
        id:6,
        title:"Full Stack",
        slug:"full-stack",
        image_url:"/services/stack.svg",
        description:"Team Vital is expert in both frontend and backend technologies, they also knows how to: Program a browser (like using JavaScript, React, jQuery, Angular, or Vue) Program a server (like using PHP, ASP, Python, or Node).",
        link:"#!",
    },
]
